import * as React from "react";

export const Comp = () => <>Comp</>;
export default Comp;
